import React from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "context/AuthContext"

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth()

  return isAuthenticated ? <>{children}</> : <Navigate to="/login"/>
}

export default PrivateRoute
